var _g, _path, _path2, _g2, _g3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsolidated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_20_1",
    "data-name": "Component 20 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.395,
    height: 39.118,
    viewBox: "0 0 38.395 39.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3574",
    "data-name": "Group 3574",
    transform: "translate(11.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M832.458,835.841v31.269l-23.733.238a1.088,1.088,0,0,1-1.1-1.087V831.492a1.088,1.088,0,0,1,1.087-1.087h18.307Z",
    transform: "translate(-806.54 -829.318)",
    fill: "#eff7fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553_-_Outline",
    "data-name": "Path 553 - Outline",
    d: "M808.8,829.405h18.758l6.073,6.073v32.8l-24.83.249a2.177,2.177,0,0,1-2.175-2.175V831.58A2.177,2.177,0,0,1,808.8,829.405Zm17.857,2.174H808.8v34.769l22.656-.227V836.379Z",
    transform: "translate(-806.627 -829.405)",
    fill: "#358aca"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M4.729,6.267-.707.831.831-.707,6.267,4.729Z",
    transform: "translate(31.813 1.026)",
    fill: "#358aca"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M831.929,838H823.67v-8.259h2.174v6.084h6.084Z",
    transform: "translate(-793.75 -829.376)",
    fill: "#358aca"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3575",
    "data-name": "Group 3575",
    transform: "translate(17.191 11.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M14.684,1.175H0V-1H14.684Z",
    transform: "translate(0 1)",
    fill: "#358aca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M14.684,1.175H0V-1H14.684Z",
    transform: "translate(0 4.57)",
    fill: "#358aca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M6.884,1.175H0V-1H6.884Z",
    transform: "translate(0.061 8.139)",
    fill: "#358aca"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3576",
    "data-name": "Group 3576",
    transform: "translate(0 10.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M804.445,854.128,799.882,841.4l2.542.005-.346-2.176-2.193,0h0a2.174,2.174,0,0,0-2.048,2.908l8.448,23.552Z",
    transform: "translate(-797.707 -839.23)",
    fill: "#b4cd7c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M806.637,852.253l-2.492-15.68,2.492.006V834.4l-2.487-.006h-.007A2.176,2.176,0,0,0,802,836.914l4.64,29.2Z",
    transform: "translate(-796.799 -828.969)",
    fill: "#b4cd7c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsolidated);
export default __webpack_public_path__ + "static/media/consolidated.c1c6e56adf69c8c84107e4ac276a1844.svg";
export { ForwardRef as ReactComponent };